// const baseURL = "https://stagingapi.myclnqhealth.com/"; //Stging
const baseURL = "https://backend.myclnq.co/"; //Production/

const config = {
  baseURL,
};

export default config;
